<template>
<messaging-bar class="highlighted field-container">
  <div class="field ">
      <textarea class="textarea"
      @input="resizeTextarea"
      @keydown.enter.exact.prevent
      @keyup.exact.enter="submit"
      @keyup.exact.shift.enter="resizeTextarea"
      @click="onCaretPositionChange"
      @focus="onCaretPositionChange"
      @change="onCaretPositionChange"
      v-model.trim="textContent"
  placeholder="Enter your message" :focus="true"></textarea>
  </div>
</messaging-bar>
</template>

<script>
import MessagingBar from '@/components/messaging/messaging-bar'
import TextField from '@/components/general/text-field'

export default {
  components: {
    MessagingBar, TextField
  },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      caretStartPosition: 0
    }
  },
  computed: {
    textContent: {
      get () {
        return this.text
      },
      set (value) {
        this.$emit('update:text', value)
      }
    }
  },
  methods: {
    submit (e) {
      this.$emit('submit')
      const self = this
      setTimeout(function () {
        self.$emit('update:text', '')
        e.target.style.height = '2.5rem'
        self.$el.style['min-height'] = '4.5rem'
      }, 500)
    },
    resizeTextarea (e) {
      let elmHeight = Number(e.target.scrollHeight)
      let wraperHeight = elmHeight
      if (elmHeight < 40) {
        elmHeight = 40
      }
      if (elmHeight <= 320) {
        wraperHeight += 32
      } else {
        elmHeight = 320
        wraperHeight = 352
      }
      e.target.style.height = 'auto'
      e.target.style.height = elmHeight + 'px'
      this.$el.style['min-height'] = wraperHeight + 'px'
    },
    replaceAt (text, index, replacement) {
      return `${text.substr(0, index)}${replacement}${text.substr(index + replacement.length)}`
    },
    addEmoji (emoji) {
      // console.table(selected)
      const updatedText = this.replaceAt(this.textContent, this.caretStartPosition, emoji.colons)
      this.$emit('update:text', updatedText)
    },
    onCaretPositionChange (e) {
      this.caretStartPosition = e.target.selectionStart
      // console.log('Caret at ', this.caretStartPosition)
      // if (start % 8 === 0) {
      //   const updatedText = this.replaceAt(this.textContent, start, new Date().getSeconds())
      //   this.$emit('update:text', updatedText)
      //   e.selectionEnd = Number(start + 5)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.field {
  margin-bottom: 0;
}
.highlighted {
  background-color: $hover-color;
}
.textarea {
  resize: none;
  padding: 0.5rem 1rem;
  min-height: 76px;
  max-height: 76px;
  line-height: 28px;
}
.field-container{
  min-height: 110px !important;
}

.textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
    line-height:28px;
}
.textarea::-webkit-input-placeholder { /* Webkit */
    line-height:28px;
}
.textarea:-ms-input-placeholder { /* IE */
    line-height:28px;
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/input-bar.vue